import React, { useState, useEffect, useContext, FormEvent } from "react";
import { SimpleResponse } from "../../../services/api/Request";
import Year, { IYear } from "../../../services/api/Year";
import AuthContext from "../../../contexts/AuthContext";
import Button from "../../../components/Form/Button";
import Input from "../../../components/Form/Input";
import YearList from "./YearList";
import Form from "./Form";

const Years: React.FC = () => {
  const { user } = useContext(AuthContext);
  const [years, setYears] = useState<IYear[]>([]);
  const readOnly = user!.profile.name === "Viewer";
  const [response, setResponse] = useState<SimpleResponse>();
  const [message, setMessage] = useState<string>('');

  async function LoadYears() {
    const response: IYear[] = await Year.GetAll();
    setYears(response);
  }

  useEffect(() => {
    LoadYears();
  }, []);

  function toggleForm(e: any) {
    e.target.nextElementSibling.classList.toggle("form--open");
    e.target.parentNode.parentNode.parentNode.parentNode.classList.toggle(
      "form--open"
    );
  }

  async function handleFormSubmit(event: FormEvent) {
    event.preventDefault();
    
    const formData: FormData = new FormData(event.target as HTMLFormElement);
   // const response: SimpleResponse = await System.ImportForecast(formData);
    //setResponse(response);
    
}

  return (
    <React.Fragment>
        <section className="content__block">
            <div className="content__header">
                <h2 className="content__title">Available years</h2>
                <div className="multi-selects">
                    <div className="content__select">
                        <button
                            disabled={readOnly}
                            onClick={toggleForm}
                            className="button button--blue button--icon button--add"
                        >
                            Add New
                        </button>
                        <div className="form--float">
                            <Form year={{} as IYear} />
                        </div>
                    </div>
                </div>
            </div>
                    <div className="groups edit__buttons">
                        <YearList years={years} />
                    </div>
        </section>
    </React.Fragment>
  );
};

export default Years;
